"use client";

import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";

import { getFunctionFacetIdsForProduct } from "@/actions/product-facet-work";
import { queryKeys } from "@/constants/query";
import { isValidOrgId } from "@/lib/utils";

export function useFunctionFacetIdsForProduct(
  productRootId: string | undefined,
): {
  functionFacetIds: Set<string>;
  isLoading: boolean;
} {
  const { orgId } = useParams();
  const validOrgId = isValidOrgId(orgId as string | undefined)
    ? (orgId as string)
    : undefined;

  const { data = [], isLoading } = useQuery({
    queryKey: queryKeys.functionFacetIdsForProduct(
      validOrgId ?? "",
      productRootId ?? "",
    ),
    queryFn: (): Promise<string[]> =>
      getFunctionFacetIdsForProduct(validOrgId!, productRootId!),
    enabled: !!validOrgId && !!productRootId,
    staleTime: 60_000,
  });

  return {
    functionFacetIds: new Set(data),
    isLoading,
  };
}
